"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayItem = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var react_1 = __importDefault(require("react"));
var label_1 = require("./label");
var value_1 = require("./value");
function DisplayItem(props) {
    var name = props.name, field = props.field, value = props.value;
    var type = field.inputType, metadata = field.inputMetadata;
    var testId = "DisplayItem-" + name;
    var label = (metadata === null || metadata === void 0 ? void 0 : metadata.label) || (metadata === null || metadata === void 0 ? void 0 : metadata.subText) || '';
    switch (type) {
        // @deprecated this should be removed after the DSL backend remove its usage
        case 'currencywithnumber': {
            var typedValue = value;
            return (react_1.default.createElement(core_ui_1.Flexbox, { gap: 16, flexDirection: "row" },
                react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column" },
                    react_1.default.createElement(label_1.Label, { name: name + "-currency", label: label }),
                    react_1.default.createElement(value_1.Value, { name: name + "-currency", field: __assign(__assign({}, (field.properties || {}).moneyLimit), { inputMetadata: metadata, inputType: dsl_schema_api_1.InputType.CURRENCY, errors: {} }), value: typedValue === null || typedValue === void 0 ? void 0 : typedValue.moneyLimit })),
                react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column" },
                    react_1.default.createElement(label_1.Label, { name: name + "-number", label: (metadata === null || metadata === void 0 ? void 0 : metadata.numberFieldLabel) || '' }),
                    react_1.default.createElement(value_1.Value, { name: name + "-number", field: {
                            inputMetadata: metadata,
                            inputType: dsl_schema_api_1.InputType.NUMBER,
                            errors: {},
                        }, value: typedValue === null || typedValue === void 0 ? void 0 : typedValue.durationInMonthsLimit }))));
        }
        case 'checkbox':
            return react_1.default.createElement(core_ui_1.CheckboxRow, { testId: testId, label: (metadata === null || metadata === void 0 ? void 0 : metadata.checkboxLabel) || '', isActive: !!value, disabled: true });
        default:
            break;
    }
    return (react_1.default.createElement(core_ui_1.Flexbox, { flexDirection: "column" },
        react_1.default.createElement(label_1.Label, { name: name, label: label }),
        react_1.default.createElement(value_1.Value, { name: name, field: field, value: value })));
}
exports.DisplayItem = DisplayItem;
